export default {
  title: 'Program & Locație',
  set_different_opening_hours: 'Setați program diferit pentru livrare',
  delivery_opening_hours: 'Program de livrare',
  sections: {
    general: 'Program general',
    holidays: 'Pauză comenzi (sărbători)',
    create_time: 'Adăugați interval orar',
    edit_time: 'Editați intervalul',
    delivery_schedule: 'Program livrare',
  },
  tabs: {
    open_times: 'Program',
    location: 'Locație',
  },
  form: {
    select_all: {
      label: 'Selectați toate zilele',
    },
    holiday_starts_at: {
      label: 'Dată început',
    },
    holiday_ends_at: {
      label: 'Dată sfârșit',
    },
    has_delivery_schedule: {
      label: 'Setați program diferit pentru livrare',
    },
    has_multiple_locations: {
      label: 'Setați locații diferite pentru săptămână',
    },
  },
  labels: {
    day_location: 'Locație {{day}} {{index}}',
    selected_days: 'Zile selectate',
    orders_paused: 'Comenzi întrerupte',
    open_time: 'Oră deschidere',
    close_time: 'Oră închidere',
  },
  errors: {
    close_time: 'Ora de închidere nu poate fi 00:00. Introduceți 23:59',
  },
  buttons: {
    edit: 'Editați',
    add_schedule_unit: 'Adăugați interval orar',
    add_holiday: 'Adăugați sărbătoare',
    delete: 'Ștergeți',
    save: 'Salvați',
    cancel: 'Anulați',
  },
  toasts: {
    changes_got_saved: 'Informațiile au fost actualizate cu succes',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
  },
};
